import { type RefObject, useEffect, useState } from 'react';

/**
 * Custom hook to determine if a container is scrollable on the X axis.
 */
export function useIsScrollable(containerRef: RefObject<HTMLElement>) {
	const [canScroll, setCanScroll] = useState(false);
	useEffect(() => {
		const checkScrollable = () => {
			if (!containerRef.current) return;
			const { scrollWidth, clientWidth } = containerRef.current;
			setCanScroll(scrollWidth > clientWidth);
		};

		checkScrollable();
		// Recheck after a small delay to ensure the DOM is updated
		const timer = setTimeout(checkScrollable, 100);
		const resizeObserver = new ResizeObserver(checkScrollable);
		if (containerRef.current) {
			resizeObserver.observe(containerRef.current);
		}
		return () => {
			clearTimeout(timer);
			resizeObserver.disconnect();
		};
	}, [containerRef]);
	return canScroll;
}
